(function () {
  'use strict';

  var textarea = document.getElementById('rh-order-note');
  if (!textarea) return;

  var statusEl  = document.querySelector('.rh-order-notes__status');
  var saveTimer = null;

  textarea.addEventListener('input', function () {
    if (saveTimer) clearTimeout(saveTimer);
    setStatus('saving', 'Saving...');
    saveTimer = setTimeout(function () {
      saveNote(textarea.value);
    }, 800);
  });

  function saveNote(note) {
    fetch('/cart/update.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body:    JSON.stringify({ note: note })
    })
    .then(function (res) {
      if (!res.ok) throw new Error('Update failed');
      return res.json();
    })
    .then(function () {
      setStatus('saved', 'Saved');
      setTimeout(function () { setStatus('', ''); }, 2000);
      // Sync the saved note into the cart drawer textarea so it shows without a page refresh
      document.querySelectorAll('.js-cart-notes-field, #cart-drawer-note textarea, #note').forEach(function (el) {
        if (el !== textarea) el.value = note;
      });
    })
    .catch(function () {
      setStatus('error', 'Could not save — please try again');
    });
  }

  function setStatus(state, text) {
    if (!statusEl) return;
    statusEl.textContent  = text;
    statusEl.className    = 'rh-order-notes__status' + (state ? ' rh-order-notes__status--' + state : '');
  }

})();
